import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// if user has permission return props.children
// else return null
const ShowForPermission = props => {
  if (props.permission === null || props.permission === undefined) {
    return props.children;
  } else if (Array.isArray(props.permission)) {
    if (props.permission.length === 0) {
      return props.children;
    }

    for (const p of props.permission) {
      const hasPermission =
        !!props.userPermissions &&
        !!props.userPermissions.find(x => x.keyName === p);
      if (hasPermission) {
        return props.children;
      }
    }

    return null;
  } else if (typeof props.permission === 'string') {
    const hasPermission =
      !!props.userPermissions &&
      !!props.userPermissions.find(x => x.keyName === props.permission);

    if (hasPermission) {
      return props.children;
    } else {
      return null;
    }
  }

  return null;
};

ShowForPermission.propsTypes = {
  permission: PropTypes.string.isRequired,
  userPermissions: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  userPermissions:
    state.authReducer.meInfo && state.authReducer.meInfo.selectedRole
      ? state.authReducer.meInfo.selectedRole.permissions
      : [],
});

export default connect(mapStateToProps)(ShowForPermission);
